import React from 'react';

import DegreeBenefits from 'Jsx/CheckoutV4/pages/CheckoutDesktop/components/PurchaseDetail/ProductDetail/DegreeDetail/DegreeBenefits';

const DegreeDetail = () => (
  <div className="mt-20">
    <DegreeBenefits />
  </div>
);

export default DegreeDetail;
